<template>
    <div class="userInput-wrap">
        <div class="userInput-content" :class="{ userInputSjtu: owner === 'SJTU' }">{{ content }}</div>
        <div class="userInput-portrait" v-if="owner !== 'SJTU'">
            <!-- <i class="iconfont icon-ecard-head-portrait"></i> -->
            <img :src="portrait" alt="portrait" />
        </div>
    </div>
</template>

<script>
import { domain } from '../Service/api'
export default {
  props: {
    content: {
      type: String
    },
    owner: String
  },
  data () {
    return {
      portrait: `https://oss.${domain}/ms-system/ecardServer/test/gallery/1000002891-99548856bf7f439bb5dec4f634c587ca.png`
    }
  }
}
</script>

<style lang="scss" scoped>
.userInput {
    &-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        &:not(:first-child) {
            margin-top: 44px;
        }
    }

    &-content {
        color: #fff;
        background: #4e82ff;
        max-width: 480px;
        padding: 16px 24px;
        line-height: 44px;
        font-size: 32px; /*px*/
        word-break: break-all;
        word-wrap: word-break;
        font-weight: 400;
        border-radius: 12px;
    }

    &-portrait {
        margin-left: 20px;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: #dcdcdc;

        .iconfont {
            color: #ffffff;
            font-size: 32px; /*px*/
        }
    }
}
.userInputSjtu {
    background: #016aed !important;
    .iconfont {
        color: #ffffff;
        font-size: 32px; /*px*/
    }
}
.userInput-portrait {
    margin-right: 20px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    img {
        width: 100%;
        background-color: #ffffff;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/UserInput.vue